module.exports = __webpack_public_path__ + "e7311af13b85ccb2eeb80f1e759b86ad.svg";